<h2 mat-dialog-title class="dialog-header">
    <mat-icon class="mr-2 entity-positions">business</mat-icon>
    {{ position?.name || position?.mainTitle || 'Org Part Details' }}

    <button mat-icon-button mat-dialog-close class="close-button">
        <mat-icon>close</mat-icon>
    </button>
</h2>

<mat-dialog-content class="position-details-content">
    <div class="position-details-layout" *ngIf="position">
        <!-- Left Sidebar -->
        <aside class="position-sidebar" [style.background]="getSidebarGradient()">
            <button
                mat-icon-button
                *ngIf="orgDialogService.mayEdit"
                class="sidebar-edit-button"
                (click)="openEditDialog()"
                matTooltip="Edit Org Part"
            >
                <mat-icon>edit</mat-icon>
            </button>
            <div class="position-avatar-section">
                <div class="position-avatar">
                    <mat-icon class="avatar-icon">business</mat-icon>
                </div>
                <h3 class="position-name">{{ position.name || position.mainTitle }}</h3>
                <span class="position-type" *ngIf="position.partType">{{ position.partType | titlecase }}</span>
            </div>

            <mat-divider></mat-divider>

            <div class="position-quick-stats">
                <div class="stat-row" *ngIf="position.depth !== undefined">
                    <mat-icon>layers</mat-icon>
                    <span class="stat-label">LEVEL {{ position.depth }}</span>
                </div>
                <div class="stat-row">
                    <mat-icon>subdirectory_arrow_right</mat-icon>
                    <span class="stat-label">{{ childPositions.length }} CHILDREN</span>
                </div>
                <div class="stat-row">
                    <mat-icon>school</mat-icon>
                    <span class="stat-label">{{ relatedHats.length }} HATS</span>
                </div>
                <div class="stat-row">
                    <mat-icon>person</mat-icon>
                    <span class="stat-label">{{ relatedUsers.length }} STAFF</span>
                </div>
            </div>

            <mat-divider *ngIf="parentPosition"></mat-divider>

            <div class="position-parent" *ngIf="parentPosition">
                <span class="parent-label">PARENT</span>
                <div class="parent-link" (click)="viewParent()">
                    <mat-icon>arrow_upward</mat-icon>
                    <span>{{ parentPosition.name || parentPosition.mainTitle }}</span>
                </div>
            </div>

            <div class="position-path" *ngIf="position.path">
                <span class="path-label">PATH</span>
                <span class="path-value">{{ position.path }}</span>
            </div>

            <!-- VFP Summary in Sidebar -->
            <div class="position-vfp-sidebar" *ngIf="position.vfp">
                <mat-divider></mat-divider>
                <div style="margin-top: 12px">
                    <span
                        class="vfp-sidebar-label"
                        style="
                            font-size: 11px;
                            text-transform: uppercase;
                            letter-spacing: 0.5px;
                            opacity: 0.7;
                            font-weight: 700;
                            display: flex;
                            align-items: center;
                            gap: 4px;
                        "
                    >
                        <mat-icon style="font-size: 16px; width: 16px; height: 16px">emoji_events</mat-icon>
                        VFP
                    </span>
                    <span
                        class="vfp-sidebar-value"
                        style="
                            font-size: 13px;
                            display: block;
                            margin-top: 4px;
                            line-height: 1.4;
                            font-weight: 700;
                            word-wrap: break-word;
                            overflow-wrap: break-word;
                        "
                        >{{ position.vfp }}</span
                    >
                </div>
            </div>
        </aside>

        <!-- Main Content -->
        <main class="position-main-content">
            <!-- VFP (Valuable Final Product) Section -->
            <div
                class="vfp-editor-section"
                style="padding: 16px 24px; border-bottom: 1px solid rgba(255, 255, 255, 0.1)"
            >
                <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 12px">
                    <mat-icon style="color: #ffd54f">emoji_events</mat-icon>
                    <h3 style="margin: 0; font-size: 16px; font-weight: 700">Valuable Final Product</h3>
                </div>
                <div *ngIf="!isEditingVfp">
                    <p
                        *ngIf="position.vfp"
                        style="
                            margin: 0;
                            font-size: 14px;
                            line-height: 1.6;
                            font-weight: 700;
                            white-space: pre-wrap;
                            word-wrap: break-word;
                            overflow-wrap: break-word;
                        "
                    >
                        {{ position.vfp }}
                    </p>
                    <p *ngIf="!position.vfp" style="margin: 0; font-style: italic; opacity: 0.5; font-size: 14px">
                        No VFP defined for this position.
                    </p>
                    <button
                        *ngIf="orgDialogService.mayEdit"
                        mat-stroked-button
                        style="margin-top: 12px; font-size: 13px"
                        (click)="startEditingVfp()"
                    >
                        <mat-icon style="font-size: 18px; width: 18px; height: 18px; margin-right: 4px">edit</mat-icon>
                        {{ position.vfp ? 'Edit VFP' : 'Add VFP' }}
                    </button>
                </div>
                <div *ngIf="isEditingVfp">
                    <textarea
                        #vfpDialogInput
                        style="
                            width: 100%;
                            min-height: 120px;
                            background: rgba(0, 0, 0, 0.15);
                            border: 1px solid rgba(255, 255, 255, 0.2);
                            border-radius: 6px;
                            color: inherit;
                            font-size: 14px;
                            padding: 12px;
                            resize: vertical;
                            font-family: inherit;
                            line-height: 1.6;
                            box-sizing: border-box;
                        "
                        [value]="position.vfp || ''"
                        placeholder="Describe the Valuable Final Product of this position... What is the end result that this position is responsible for producing?"
                    ></textarea>
                    <div style="margin-top: 12px; display: flex; gap: 8px">
                        <button mat-raised-button color="primary" (click)="saveVfp(vfpDialogInput.value)">
                            <mat-icon>save</mat-icon> Save VFP
                        </button>
                        <button mat-button (click)="cancelEditingVfp()">Cancel</button>
                    </div>
                </div>
            </div>

            <!-- HFA participation (posts only) -->
            <div
                class="vfp-editor-section"
                *ngIf="isPost"
                style="padding: 16px 24px; border-bottom: 1px solid rgba(255, 255, 255, 0.1)"
            >
                <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 12px">
                    <mat-icon style="color: #8a5a00">account_tree</mat-icon>
                    <h3 style="margin: 0; font-size: 16px; font-weight: 700">Part of running the org</h3>
                </div>
                <div style="display: flex; align-items: flex-start; justify-content: space-between; gap: 16px">
                    <p style="margin: 0; font-size: 13px; opacity: 0.7; line-height: 1.5">
                        When on, this post's occupant is "held from above" onto positions below it (the way the CEO is).
                        Turn it OFF for a governance/board seat that oversees but doesn't run the org — they'll only
                        show on their own post.
                    </p>
                    <mat-slide-toggle
                        color="primary"
                        [checked]="holdsFromAbove"
                        [disabled]="!orgDialogService.mayEdit"
                        (change)="onHoldsFromAboveChange($event.checked)"
                    ></mat-slide-toggle>
                </div>
            </div>

            <!-- Linked post: it represents another post and comes from there — read-only, with a
                 way to go to the origin (links are set only by the migration). -->
            <div
                class="vfp-editor-section linked-origin-section"
                *ngIf="isPost && origin as o"
                style="padding: 16px 24px; border-bottom: 1px solid rgba(255, 255, 255, 0.1)"
            >
                <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 6px">
                    <mat-icon style="color: #7986cb">link</mat-icon>
                    <h3 class="linked-origin-title" style="margin: 0; font-size: 16px; font-weight: 700">
                        Represents {{ o.name }}
                    </h3>
                </div>
                <p class="linked-origin-path" style="margin: 0 0 4px; font-size: 13px; opacity: 0.7">
                    {{ o.path.join(' › ') }}
                </p>
                <p style="margin: 0 0 12px; font-size: 13px; opacity: 0.7; line-height: 1.5">
                    Shows whoever holds {{ o.name }}. Change or staff it there.
                </p>
                <button mat-stroked-button color="primary" class="linked-origin-go" (click)="goToOrigin()">
                    <mat-icon>arrow_outward</mat-icon>
                    Go to origin
                </button>
            </div>

            <mat-accordion class="sections-accordion" multi>
                <!-- Child Positions Section -->
                <mat-expansion-panel
                    [expanded]="sectionStates.children"
                    (expandedChange)="sectionStates.children = $event"
                    *ngIf="childPositions.length > 0"
                >
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon class="entity-positions">subdirectory_arrow_right</mat-icon>
                            Child Positions ({{ childPositions.length }})
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="children-list">
                        <div
                            *ngFor="let child of childPositions"
                            class="child-item clickable"
                            [class.is-post]="child.partType.toLowerCase() === 'post'"
                            (click)="viewChildPosition(child)"
                        >
                            <div
                                class="child-avatar"
                                [style.background-color]="child.partType.toLowerCase() === 'post' ? '#1976d2' : (child.colour?.background || '#4fc3f7')"
                            >
                                >
                                <mat-icon>business</mat-icon>
                            </div>
                            <div class="child-info">
                                <span class="child-name">{{ child.name | titlecase }}</span>
                                <span class="child-type" *ngIf="child.partType">{{ child.partType }}</span>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>

                <!-- Hats at Position Section -->
                <mat-expansion-panel
                    [expanded]="sectionStates.hats"
                    (expandedChange)="sectionStates.hats = $event"
                    *ngIf="relatedHats.length > 0"
                >
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon class="entity-hats">school</mat-icon>
                            Hats at Position ({{ relatedHats.length }})
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="hats-list">
                        <div *ngFor="let hat of relatedHats" class="hat-item clickable" (click)="viewHat(hat)">
                            <div class="hat-avatar">
                                <mat-icon>school</mat-icon>
                            </div>
                            <div class="hat-info">
                                <span class="hat-name">{{ hat.name | titlecase }}</span>
                                <span class="hat-users">{{ hat.userCount }} staff member(s)</span>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>

                <!-- Users at Position Section -->
                <mat-expansion-panel
                    [expanded]="sectionStates.users"
                    (expandedChange)="sectionStates.users = $event"
                    *ngIf="relatedUsers.length > 0 || pendingUsers.length > 0"
                >
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon class="entity-users">people</mat-icon>
                            Staff at Org Part ({{ relatedUsers.length }})
                            <span *ngIf="pendingUsers.length" style="color: #ff9800; font-size: 12px; margin-left: 8px">
                                +{{pendingUsers.length}} pending
                            </span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="users-list">
                        <div *ngFor="let user of relatedUsers" class="user-item clickable" (click)="viewUser(user)">
                            <div
                                class="user-avatar"
                                [style.background-image]="'url(' + getUserAvatarUrl(user) + ')'"
                                style="background-size: cover; background-position: center"
                            ></div>
                            <div class="user-info">
                                <span class="user-name">{{ user.name }}</span>
                                <span class="user-hat">via {{ user.viaHat }}</span>
                            </div>
                        </div>
                        <!-- Pending Users -->
                        <div
                            *ngFor="let user of pendingUsers"
                            class="user-item"
                            style="border: 1px dashed #ff9800; background: #fff8e1; border-radius: 8px"
                        >
                            <div
                                class="user-avatar"
                                [style.background-image]="'url(' + getUserAvatarUrl(user) + ')'"
                                style="background-size: cover; background-position: center; opacity: 0.7"
                            ></div>
                            <div class="user-info">
                                <span class="user-name">{{ user.name }}</span>
                                <span class="user-hat">via {{ user.viaHat }}</span>
                                <span style="font-size: 10px; color: #ff9800; font-weight: 500">Pending Approval</span>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>

                <!-- Security Groups Section -->
                <mat-expansion-panel
                    [expanded]="sectionStates.securityGroups"
                    (expandedChange)="sectionStates.securityGroups = $event"
                    *ngIf="relatedSecurityGroups.length > 0"
                >
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon class="entity-security-groups">security</mat-icon>
                            Security Groups ({{ relatedSecurityGroups.length }})
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="sg-list">
                        <div
                            *ngFor="let sg of relatedSecurityGroups"
                            class="sg-item clickable"
                            (click)="viewSecurityGroup(sg)"
                        >
                            <div class="sg-avatar">
                                <mat-icon>security</mat-icon>
                            </div>
                            <div class="sg-info">
                                <span class="sg-name">{{ sg.name | titlecase }}</span>
                                <span class="sg-hat">via {{ sg.viaHat }}</span>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>

                <!-- Policies Section -->
                <mat-expansion-panel
                    [expanded]="sectionStates.policies"
                    (expandedChange)="sectionStates.policies = $event"
                    *ngIf="relatedPolicies.length > 0"
                >
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon class="entity-policies">description</mat-icon>
                            Policies ({{ relatedPolicies.length }})
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="policies-list">
                        <div
                            *ngFor="let policy of relatedPolicies"
                            class="policy-item clickable"
                            (click)="viewPolicy(policy)"
                        >
                            <div class="policy-avatar">
                                <mat-icon>description</mat-icon>
                            </div>
                            <div class="policy-info">
                                <span class="policy-name">{{ policy.name | titlecase }}</span>
                                <span class="policy-hat">via {{ policy.viaHat }}</span>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>

                <!-- Menu Preview Section -->
                <mat-expansion-panel
                    [expanded]="sectionStates.menuPreview"
                    (expandedChange)="sectionStates.menuPreview = $event"
                    *ngIf="menuPreview.length > 0"
                >
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon class="entity-positions">menu</mat-icon>
                            Menu Preview ({{ menuPreview.length }})
                            <span class="menu-preview-subtitle">(What Staff at This Org Part Will See)</span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="menu-preview">
                        <div *ngFor="let group of menuPreview" class="menu-group">
                            <div class="menu-group-header">{{ group.section }}</div>
                            <div class="menu-items">
                                <div *ngFor="let item of group.items" class="menu-item">
                                    <mat-icon>{{ item.icon }}</mat-icon>
                                    <span>{{ item.name }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>

                <!-- Empty State -->
                <div
                    class="empty-state"
                    *ngIf="childPositions.length === 0 && relatedHats.length === 0 && relatedUsers.length === 0"
                >
                    <mat-icon class="empty-icon">business</mat-icon>
                    <p>This is a leaf position with no hats assigned</p>
                </div>
            </mat-accordion>
        </main>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
    <button mat-raised-button color="primary" (click)="openExplorer()">
        <mat-icon>account_tree</mat-icon>
        View in Explorer
    </button>
</mat-dialog-actions>
